var ko = require('knockout');
var LiteratureItemViewModel = require('./literature-item.vm.js');

function LiteratureReviewViewModel(element) {
    var self = this;
    var $element = $(element);
    self.categories = ko.observableArray([]);
    self.cartItems = ko.observableArray([]);
    self.touchstoneAssociation = ko.observable($element.find('input[name=SelectedTouchstoneAssociationValue]').val());
    self.isCartEmpty = ko.observable();

    self.isCartEmpty = ko.computed(function () {
        return self.cartItems().length === 0;
    }, this);

    if (sessionStorage.literatureCart) {
        try {
            const sessionCart = JSON.parse(sessionStorage.literatureCart);
            const sessionCartItems = sessionCart && sessionCart.items;
            let cartItems = [];

            for (let item of sessionCartItems) {
                cartItems.push(new LiteratureItemViewModel(item));
            }

            self.cartItems(cartItems);
        } catch { }
    }
}

module.exports = LiteratureReviewViewModel;